import React, {useState} from 'react';
import './businessLoans.scss';

import IDEA_ICON from "assets/icons/idea_icon.svg";
import POINTING_LADY_IMAGE from 'assets/accounting-finance/pointing_lady.png';

import {Button} from 'components';
import {useNavigate} from "react-router-dom";


const BusinessLoans = () => {
    const navigate = useNavigate();
    const [cards] = useState<{ title: string, description: string, image: any }[]>([
        {
            title: "Product Enhancement",
            description: "Enhance the quality of your products or services to meet customers need",
            image: IDEA_ICON
        },
        {
            title: "Market Expansion",
            description: "Reach more customers by producing more products to be distributed.",
            image: IDEA_ICON
        },
        {
            title: "Diversify Offer Lineup",
            description: "Extend your product lineup by Developing new products or offering new services to your customers",
            image: IDEA_ICON
        },
    ])
    return (
        <div className={'business-loans'} id={'business-loans'}>
            <div className="business-loans_wrapper max">
                <div className="business-loans_wrapper_left">
                    <div className="business-loans_wrapper_left_top">
                        <h1>Small Businesses Loans & Grants</h1>
                        <p>The SBAJ assists businesses in obtaining loans and grants from eligible organisations; to
                            help them achieve their business goals.</p>
                    </div>
                    <div className="business-loans_wrapper_left_middle">
                        <span>Reasons for business loans:</span>
                        <div className="business-loans_wrapper_left_middle_cards">
                            {cards.map(({image, title, description}, index) => (
                                <div className="business-loans_wrapper_left_middle_cards_card"
                                     key={title + index + 'bl'}>
                                    <img src={image} alt=""/>
                                    <h2>{title}</h2>
                                    <p>{description}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="business-loans_wrapper_left_bottom">
                        <p>Whatever your reason for a business loan is, we are here to help. All our members can benefit
                            from our loans and grants assistance services.</p>

                    </div>
                    <Button text={'Become A Member'} type={'primary'} onclick={() => navigate('/registration/')}/>
                </div>
                <div className="business-loans_wrapper_right">
                    <img id={'pointing-lady_loan'} src={POINTING_LADY_IMAGE} alt=""/>
                </div>
            </div>
        </div>
    );
};

export default BusinessLoans;
